import React from 'react';
import PropTypes from 'prop-types';
import { ButtonContainer, Chevron } from './styles';

const ToggleButton = ({
  dataPubli,
  device,
  title,
  active,
  setActive,
  margin = '0px 6px 0px 0px',
  widthIcon = '12px',
  heightIcon = '7.4px'
}) => (
  <ButtonContainer
    data-publi={dataPubli}
    device={device}
    onClick={e => {
      e.preventDefault();
      setActive();
    }}
    margin={margin}
  >
    {title}
    <Chevron
      data-publi={`chevron-${dataPubli}`}
      device={device}
      active={active}
      width={widthIcon}
      height={heightIcon}
    />
  </ButtonContainer>
);

export default ToggleButton;

ToggleButton.propTypes = {
  dataPubli: PropTypes.string,
  device: PropTypes.string,
  title: PropTypes.string,
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired
};
